import React from 'react';
import '../About/About.css'; 
import { FaPhoneAlt } from 'react-icons/fa';
const callAdmin = () => {
  window.location.href = 'tel: +919220347091'; // replace with real number
};
const About = () => {
  return (
    <>
      <div className='full-about'>
        <section className="about">
          <div className="left">
            <p className="intro">About Event & Conference</p>
            <h1>Delivering Memorable Events with Expertise</h1>
            <p className="description">
              श्री Var Event & Conference is a premier event management company committed to curating extraordinary experiences. From weddings and corporate events to product launches and social celebrations, we handle every detail with creativity, precision, and professionalism. With a talented team and a network of trusted vendors, we turn your ideas into unforgettable events that leave a lasting impression.
            </p>
          </div>
          <div className="right">
            <p className="highlightt">
              Whether it's a small gathering or a grand celebration, we create flawless events tailored to your vision and needs.
            </p>
            <img src="/abme3.png" loading="lazy" alt="Event Management" />
          </div>
        </section>

        <section className="call">
          <div className="call-content">
            <h1>New to Event Planning?</h1>
            <FaPhoneAlt className="phone-icon" onClick={callAdmin} />
            <div className="call-info">
              <p className="call-text">
                Contact Us At <span className="phone-number" onClick={callAdmin}> +91 922-034-7091</span>
              </p>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default About;
